const STORAGE_KEY = "rememberedDepartureAirport";

/**
 * Persists the last airport a visitor picked in FlyingFromLocation (hero-10/FlyingFromLocation.jsx)
 * so the next visit can pre-fill it as a default instead of starting blank - still fully
 * changeable, just a convenience default. Only code+name are stored (not the whole dropdown
 * item, whose `id` is just an index into that fetch's array and isn't stable across loads).
 */
export function rememberDepartureAirport(code, name) {
  if (typeof window === "undefined" || !code || !name) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ code, name }));
  } catch (error) {
    // localStorage can throw (private browsing, quota, disabled) - remembering a default
    // should never break the search box itself.
    console.warn("Could not remember departure airport", error);
  }
}

/** Reads the stored airport, silently dropping anything malformed rather than throwing. */
export function getRememberedDepartureAirport() {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    if (!parsed?.code || !parsed?.name) return null;
    return { code: parsed.code, name: parsed.name };
  } catch (error) {
    console.warn("Could not read remembered departure airport", error);
    return null;
  }
}
